import type {ReactElement} from 'react';
import {Checkbox} from '@Components/checkbox/checkbox';
import {CheckboxSize} from '@Components/checkbox/checkbox.types';
import type {SavedAccountRemovalRowProps} from './saved-account-removal-row.types';
import {SavedAccountIdentity} from '../saved-account-identity/saved-account-identity';
import {InitialsAvatarSize} from '../initials-avatar/initials-avatar.types';
import styles from './saved-account-removal-row.module.scss';
import {AuthTestId} from '@/test-ids/auth-test-id';

/**
 * One remembered account in remove mode. The row is a label around the checkbox, so the
 * whole row toggles it natively and the name and email are its accessible name.
 */
export function SavedAccountRemovalRow({account, isSelected, onToggle}: SavedAccountRemovalRowProps): ReactElement {
  const toggleRemoval = (isChecked: boolean): void => {
    onToggle(account, isChecked);
  };

  return (
    <label className={`${styles.row} ${isSelected ? styles.selected : ''}`} data-testid={AuthTestId.SAVED_ACCOUNT_ROW}>
      <Checkbox isChecked={isSelected} onChange={toggleRemoval} size={CheckboxSize.SM} />
      <SavedAccountIdentity account={account} avatarSize={InitialsAvatarSize.SMALL} />
    </label>
  );
}
